module.exports = __webpack_public_path__ + "static/media/ae4.54276118.png";